import React from 'react';
import s from './PaymentBreakdown.scss';
import classnames from 'clsx';
import {useControllerProps} from '../../../../../../domain/controllers/ControllerContext';
import {OrderSummaryDataHook} from '../OrderSummary';
import {useTranslation} from '@wix/yoshi-flow-editor';

export const PaymentBreakdown = () => {
  const {cartSummary, supportSubscriptionsInPurchaseFlow} = useControllerProps().cartStore;
  const {t} = useTranslation();

  const payNow = cartSummary.payNow.total;
  const payAfterFreeTrial = supportSubscriptionsInPurchaseFlow ? cartSummary.payAfterFreeTrial.total : undefined;
  const payLater = cartSummary.payLater.total;

  const hasFreeTrial = supportSubscriptionsInPurchaseFlow ? payAfterFreeTrial.convertedAmount > 0 : false;
  const hasPayLater = payLater.convertedAmount > 0;

  return (
    <div data-hook={OrderSummaryDataHook.PaymentBreakdownRoot} className={classnames(s.topDivider, s.root)}>
      <dl>
        <dt>
          <span data-hook={OrderSummaryDataHook.PayNowTitle} className={s.payNow}>
            {t('cart.orderSummary.amountDueNow.label')}
          </span>
        </dt>
        <dd
          data-hook={OrderSummaryDataHook.PayNowValue}
          data-wix-paynow-value={OrderSummaryDataHook.PayNowValue}
          className={s.payNow}>
          {payNow.formattedConvertedAmount}
        </dd>
      </dl>
      {supportSubscriptionsInPurchaseFlow && hasFreeTrial && (
        <dl>
          <dt>
            <span data-hook={OrderSummaryDataHook.PayAfterFreeTrialTitle}>
              {t('cart.pricingPlans.afterFreeTrial.label')}
            </span>
          </dt>
          <dd
            data-hook={OrderSummaryDataHook.PayAfterFreeTrialValue}
            data-wix-paynow-value={OrderSummaryDataHook.PayAfterFreeTrialValue}>
            {payAfterFreeTrial.formattedConvertedAmount}
          </dd>
        </dl>
      )}
      {(!supportSubscriptionsInPurchaseFlow || hasPayLater) && (
        <dl>
          <dt>
            <span data-hook={OrderSummaryDataHook.PayLaterTitle}>{t('cart.orderSummary.amountDueLater.label')}</span>
          </dt>
          <dd
            data-hook={OrderSummaryDataHook.PayLaterValue}
            data-wix-paylater-value={OrderSummaryDataHook.PayLaterValue}>
            {payLater.formattedConvertedAmount}
          </dd>
        </dl>
      )}
    </div>
  );
};
